export default "__VITE_ASSET__JODalTrn__"